module.exports = __webpack_public_path__ + "static/assets/37d16512a118d60b6077606020c23907.svg";